import { render, staticRenderFns } from "./HeaderV2.vue?vue&type=template&id=53afd8ca&scoped=true&"
import script from "./HeaderV2.vue?vue&type=script&lang=js&"
export * from "./HeaderV2.vue?vue&type=script&lang=js&"
import style0 from "./HeaderV2.vue?vue&type=style&index=0&id=53afd8ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53afd8ca",
  null
  
)

export default component.exports